import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const chatV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Updating intro content structure to support multiple messages',
  run: (props: PartialPropsOf<'chat'>): void => {
    props.version ??= 1;
    if (!(props.version < 2 && props.content)) {
      return;
    }
    const oldIntro = props.content.intro as unknown as
      | {
          currentState: 'image' | 'message';
          image: string | undefined;
          message: string;
        }
      | undefined;

    props.content.intro = {
      showImage: oldIntro?.currentState === 'image' && !!oldIntro.image,
      image: oldIntro?.image ?? '',
      messages:
        oldIntro?.currentState === 'message' && !!oldIntro?.message
          ? [{ message: oldIntro?.message }]
          : [],
    };

    props.version = 2;
  },
};
